module.exports = __webpack_public_path__ + "img/download-app-banner.5240bf39.png";